<!-- <div data-collapse="medium" data-animation="over-right" data-duration="400"
  data-w-id="6b543a3e-f9c6-f9bd-eba9-d60107508ad2" data-easing="ease-out" data-easing2="ease-in" role="banner"
  class="navbar w-nav">
  <div class="wrapper_navbar">
    <div class="menu-button w-nav-button">
      <div class="icon-2 w-icon-nav-menu"></div>
    </div>
    <a href="javascript:void(0);" routerLink="/" aria-current="page" class="brand w-nav-brand w--current"><img   loading="lazy"
        src="assets/landing-images/New-Logo-ItsGameTime-1.svg" width="430" alt="logo itsgametime"
        class="logo_itsgametime"></a>
    <nav role="navigation" class="nav-menu w-nav-menu">
      <a href="javascript:void(0);" routerLink="/" class="nav-link w-nav-link active_link">Home</a>
      <a href="javascript:void(0);" routerLink="/about" class="nav-link w-nav-link">About Us</a>
      <a href="javascript:void(0)" routerLink="/news" class="nav-link w-nav-link">News</a>
      <a href="javascript:void(0)" routerLink="/blog" class="nav-link w-nav-link">Blog</a>
      <a href="{{help_center}}" target="_blank" rel="noopener" class="nav-link w-nav-link">Help Center</a>
      <a href="javascript:void(0);" routerLink="/login"  class="button_signup w-button">Join Now / Sign In</a>
    </nav>
  </div>
</div> -->

<app-outer-header-navigation></app-outer-header-navigation>

<div id="home" class="section_hero wf-section">
  <div class="hero_flex">
    <div class="left_hero_content">
      <h1 data-w-id="5b60d5bf-ed91-515b-626d-373a5ddf0195" class="h1_hero">Connect With People Who Share Your Love For
        Sports</h1>
      <h2 data-w-id="aa07124b-e578-e245-3c54-3ba9aad1082f" class="h2_hero">See live scores &amp; statistics, get
        breaking news, and discuss your favorite sports with others. <br></h2>
      <a data-w-id="86247f64-3db1-6b0c-c2d6-444867692ddb" href="javascript:void(0);" routerLink="/login" class="button_cta_hero hero-center w-button">JOIN NOW / SIGN IN</a>
      <div class="appcon">
        <h1 data-w-id="5b60d5bf-ed91-515b-626d-373a5ddf0195" class="h1_hero">Download Our Mobile App</h1>
        <div class="applinkcontainer">
          <a href="https://apps.apple.com/in/app/itsgametime/id6451241875" target="_blank">
            <img class="applink" src="assets/images/buttons/App_Store.png" alt="app store">
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.itsgame.time" target="_blank">
            <img class="applink m-0" src="assets/images/buttons/Google_Play.png" alt="playe store">
          </a>
        </div>
      </div>
    </div>

    <div class="right_hero_image"><img loading="lazy" src="assets/landing-images/Macbook-and-Iphone-IGT-2.png" loading="eager" data-w-id="dc4f0af3-1011-2ccf-89e9-23a2b17b80ad" alt="Its Game Time Social Media Sports" class="image_hero">
      <a data-ix="fade-in-on-load-3" data-w-id="77ee3acb-ed90-3100-a896-e51c15a93fc3" class="hero-video-lightbox w-inline-block w-lightbox">
        <div class="video-lightbox-button large-color" (click)="mediaModalOpen(mediaView);"><img loading="lazy" src="assets/landing-images/Icon_play_white.png" width="30" alt="" class="video-lightbox-icon"></div>

      </a>
    </div>
  </div>
</div>
<div class="section-parallax blue wf-section">
  <div class="wrapper_heading">
    <h3 data-w-id="ac96890a-aa9c-2d6d-55d5-40c2c2e17174" class="h3 white">Get Access To All Sports</h3>
  </div>
  <div class="div_sports">
    <div class="square_sport"><img loading="lazy" src="assets/landing-images/NFL.png" alt="NFL" class="nfl"></div>
    <div class="square_sport"><img loading="lazy" src="assets/landing-images/NBA.png" alt="NBA" class="nba"></div>
    <div class="square_sport"><img loading="lazy" src="assets/landing-images/MLS.png" alt="MLS" class="mls"></div>
    <div class="square_sport mls"><img loading="lazy" src="assets/landing-images/MLB.png" alt="MLB" class="mlb"></div>
    <div class="square_sport pga"><img loading="lazy" src="assets/landing-images/PGA.png" alt="PGA Tour" class="golf"></div>
    <div class="square_sport hide_desktop"><img loading="lazy" src="assets/landing-images/WTA.png" alt="WTA" class="wta"></div>
    
  </div>
  <div class="div_sports">
    <div class="square_sport"><img loading="lazy" src="assets/landing-images/LPGA.png" alt="WTA" class="golf"></div>
    <div class="square_sport"><img loading="lazy" src="assets/landing-images/NHL.png" alt="NHL" class="nhl"></div>
    <div class="square_sport"><img loading="lazy" src="assets/landing-images/NCAA.png" alt="NCAA" class="ncaa"></div>
    <div class="square_sport"><img loading="lazy" src="assets/landing-images/ATP.png" alt="ATP" class="atp"></div>
    <div class="square_sport"><img loading="lazy" src="assets/landing-images/ipl_1.png" alt="IPL" class="ipl"></div>
    <div class="square_sport"><img loading="lazy" src="assets/landing-images/ICC_T20_World_Cup.png" alt="ICC T20 World Cup" class="ICC_T20_World_Cup"></div>

    <div class="square_sport hide_mobile"><img loading="lazy" src="assets/landing-images/WTA.png" alt="WTA" class="wta"></div>
  </div>
</div>
<a data-w-id="7f5f5699-0035-458b-6dcc-f6b37054e740" href="javascript:void(0);" routerLink="/login" class="link_cta_horizontal light_blue w-inline-block">
  <div class="text_caps blue">BECOME PART OF IT</div>
  <div class="cta_text white_blue">JOIN NOW / SIGN IN</div>
</a>
<div class="section_mobile wf-section">
  <div class="columns_sliders w-row">
    <div data-w-id="635f6222-eda6-0b7b-444a-68f72ecb145f" style="opacity:0" class="column_left_slider w-col w-col-6 w-col-stack">
      <div data-delay="4000" data-animation="cross" class="slider w-slider" data-autoplay="false" data-easing="ease" data-hide-arrows="false" data-disable-swipe="false" data-autoplay-limit="0" data-nav-spacing="3" data-duration="1000" data-infinite="true">
        <div class="mask w-slider-mask">
          <div class="slide_mobile w-slide"></div>
          <div class="slide_mobile_2 w-slide"></div>
          <div class="slide_mobile_3 w-slide"></div>
          <div class="slide_mobile_4 w-slide"></div>
        </div>
        <div class="left-arrow w-slider-arrow-left">
          <div class="icon w-icon-slider-left"></div>
        </div>
        <div class="right-arrow w-slider-arrow-right">
          <div class="icon w-icon-slider-right"></div>
        </div>
        <div class="slide-nav w-slider-nav w-round"></div>
      </div>
    </div>
    <div data-w-id="635f6222-eda6-0b7b-444a-68f72ecb1460" style="opacity:0" class="column_right_text_app w-col w-col-6 w-col-stack">
      <h4 class="h4_caps">IT&#x27;S GAME TIME, A SOCIAL MEDIA PLATFORM FOR SPORTS FANS</h4>
      <div class="paragraph_normal">It’s Game Time is a sports social media community designed to bring fellow sports
        fans from around the world together to stay updated, share, and get involved with the current world of sports.
        <br><br>It’s Game Time offers a platform for people to see live and past scores, watch the latest sports
        videos as they happen, and discuss their favorite sports with other fans. <br><br>We welcome people from all
        walks of life, fanatics of any sport, to share ideas and opinions with other like-minded individuals
      </div>
      <a data-w-id="7c064233-786b-809d-da95-b7fa0b6c3485" style="opacity:0" href="javascript:void(0);" routerLink="/login" class="button_cta_hero hero-center left-phone w-button">JOIN NOW / SIGN IN</a>
    </div>
  </div>
</div>
<a data-w-id="4acb8bc7-be83-62b7-786b-ecaa3c8a3b7f" href="javascript:void(0);" routerLink="/login" class="link_cta_horizontal w-inline-block">
  <h1 class="text_caps">BECOME PART OF IT</h1>
  <div class="cta_text">JOIN NOW / SIGN IN</div>
</a>
<div class="section-features wf-section">
  <div class="wrapper-features">
    <div data-w-id="ab3a61c4-05d5-a422-c845-00ae6d89b5dc" style="opacity:0" class="div_block_features">
      <div>
        <h4 class="heading-features centered">Follow Live Scores, Results, Statistics And More...</h4>
        <div class="seperator-line centered"></div>
        <div class="paragraph-features centered">Get access to live scores, see past results, and analyze statistics
          of your favorite players and teams, while discussing and sharing these with other fans.</div>
      </div>
      <div class="div_wrapper_center"><img loading="lazy" src="assets/landing-images/MLS-Profile-1.png" width="664" data-w-id="a8a3ae95-0ff7-08e4-1150-c1c7fbe60cb5" alt="MLS profile score its game time social media" class="image-live-score"></div>
    </div>
    <div class="column-features w-row">
      <div data-w-id="a1a6bf1d-ea26-d27b-e62e-1fccabee68d5" style="opacity:0" class="column-9 w-col w-col-6 w-col-stack">
        <div class="blue_frame_image_feature"><img loading="lazy" src="assets/landing-images/Connect---IGT-1.png" alt="connect profile its game time" class="image_feature horiz"></div>
      </div>
      <div data-w-id="a1a6bf1d-ea26-d27b-e62e-1fccabee68d6" style="opacity:0" class="column-8 w-col w-col-6 w-col-stack">
        <div class="div_features">
          <h5 class="heading-features">Connect &amp; Engage With Friends</h5>
          <div class="seperator-line"></div>
          <p class="paragraph-features">Create a profile, follow friends that share the same passion, and start
            discussing with them the latest sports news, trends, results, videos, and much more.</p>
          <a data-w-id="b0636bd4-d31d-4041-90e0-a73e445cc7bd" style="opacity:0" href="javascript:void(0);" routerLink="/login" class="button_cta_hero w-button">JOIN NOW / SIGN IN</a>
        </div>
      </div>
    </div>
    <div class="column-features _2 w-row">
      <div data-w-id="66dcaacd-670e-464a-ebc4-bd038944643a" style="opacity:0" class="column_image_feature w-col w-col-6 w-col-stack">
        <div class="blue_frame_image_feature"><img loading="lazy" src="assets/landing-images/Max-Millet-Post-1.png" alt="Share post Its Game Time" class="image_feature"></div>
      </div>
      <div class="column-11 w-col w-col-6 w-col-stack">
        <div class="div_features left">
          <h5 class="heading-features">Share &amp; Discuss</h5>
          <div class="seperator-line"></div>
          <p class="paragraph-features">Post about sports, start discussions, share videos with other sports
            enthusiasts, and become part of a like-minded community.</p>
          <a data-w-id="8e2516da-8a6d-fff6-e05b-bd1b219d5dd2" style="opacity:0" href="javascript:void(0);" routerLink="/login" class="button_cta_hero w-button">JOIN NOW / SIGN IN</a>
        </div>
      </div>
    </div>
    <div class="column-features _3 w-row">
      <div data-w-id="6a6c8723-3480-51d4-d3a7-49f5a068cdc3" style="opacity:0" class="column-12 w-col w-col-6 w-col-stack">
        <div class="blue_frame_image_feature"><img loading="lazy" src="assets/landing-images/Stats---NBA-2-p-800.png" sizes="(max-width: 479px) 85vw, (max-width: 767px) 71vw, (max-width: 991px) 79vw, (max-width: 1919px) 39vw, 605.6953125px" alt="replay videos Its Game Time" class="image_feature stats-img"></div>
      </div>
      <div data-w-id="6a6c8723-3480-51d4-d3a7-49f5a068cdc5" style="opacity:0" class="column-13 w-col w-col-6 w-col-stack">
        <div class="div_features">
          <h5 class="heading-features">Access All The Statistics About Teams And Players</h5>
          <div class="seperator-line"></div>
          <p class="paragraph-features">Never miss the highlights of any game, tournament, or event. Analyze all the
            stats you want on It’s Game Time.<br></p>
          <a data-w-id="5b7524a2-00e5-d9c7-c0be-dc5a96f813b5" style="opacity:0" href="javascript:void(0);" routerLink="/login" class="button_cta_hero w-button">JOIN NOW / SIGN IN</a>
        </div>
      </div>
    </div>
    <div class="column-features _2 w-row">
      <div data-w-id="59da6779-cc6d-ccd6-c60e-691a4f15b2bb" style="opacity:0" class="column_image_feature w-col w-col-6 w-col-stack">
        <div class="blue_frame_image_feature"><img loading="lazy" src="assets/landing-images/Breaking-News-1.png" alt="Purchase Tickets Its Game Time" class="image_feature tickets"></div>
      </div>
      <div data-w-id="59da6779-cc6d-ccd6-c60e-691a4f15b2be" style="opacity:0" class="column-11 w-col w-col-6 w-col-stack">
        <div class="div_features left">
          <h5 class="heading-features">Read And Share The Latest News Of Your Favorite Sports</h5>
          <div class="seperator-line"></div>
          <p class="paragraph-features">Never miss any news thanks to the latest articles provided by It&#x27;s Game
            Time. You can news on your own timeline, on a Fan&#x27;s timeline, on your followed sports timeline, or
            even send it with direct message.</p>
          <a data-w-id="29985883-d525-5c2d-964c-42961b6c5f60" style="opacity:0" href="javascript:void(0);" routerLink="/login" class="button_cta_hero w-button">JOIN NOW / SIGN IN</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="footer_new">
  <div class="wrapper_footer">
    <a href="javascript:void(0);" routerLink="/" aria-current="page" class="w-inline-block w--current"><img loading="lazy" src="assets/landing-images/New-Logo-ItsGameTime-1.png" alt="Its Game Time Sports Logo" class="logo_footer"></a>
    <div class="wrapper_footer_links">
      <a href="javascript:void(0);" routerLink="/about" class="footer-link">About us</a>
      <a href="javascript:void(0);" routerLink="/login" class="footer-link">Join now</a>
      <a href="{{help_center}}" target="_blank" rel="noopener" class="footer-link">Help center</a>
      <a href="{{terms_condition}}" target="_blank" rel="noopener" class="footer-link">Terms &amp; conditions</a>
      <a href="{{site_map}}" target="_blank" rel="noopener" class="footer-link">Sitemap</a>
      <a href="{{news_site_map}}" target="_blank" rel="noopener" class="footer-link">News Sitemap</a>
    </div>
  </div>
  <div class="div-block-47">
    <div class="wrapper_under_footer">
      <a href="{{privacy_policy}}" target="_blank" rel="noopener" class="text_under_footer">Privacy &amp; cookie policy (Your privacy
        rights)</a>
      <div class="text_under_footer no_link">© 2022 ITSGAMETIME. All rights reserved.</div>
    </div>
  </div>
</div>



<ng-template #mediaView>
  <div class="modal-header img-modal-header py-0 border-0 mb-3 mb-3">
    <button type="button" class="close pull-right img-mobile-close" aria-label="Close" (click)="modalRef.hide()" style="opacity: 1;">
      <span aria-hidden="true"><span class="text-white mdi mdi-window-close mdi-24px"></span></span>
    </button>
  </div>
  <div class="modal-body p-0 img-modal-body d-flex justify-content-center" id="my-carousel">
    <iframe class="iframeSize" src="https://www.youtube.com/embed/GX0Rb75K-RI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
</ng-template>